import { useQuery } from "@tanstack/react-query";

import { userNotificationPreferencesQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UserNotificationPreferenceResponse } from "@/types";

export function useGetUserNotificationPreferences() {
  return useQuery({
    queryKey: userNotificationPreferencesQueryKey,
    queryFn: async () => {
      const path = "user-notification-preferences";
      const res = await guacHttpClient.get<
        UserNotificationPreferenceResponse[],
        HttpResponse<UserNotificationPreferenceResponse[]>
      >(path);
      return res.data;
    },
  });
}
